import React from "react";
import { RightSideCountTop } from "../../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";

const UserStats = ({ selectedTab, statData, ...props }) => {
  return (
    <>
      {selectedTab === "1" && (
        <RightSideCountTop
          content={[
            {
              name: "Reservations",
              value: statData.reservations || 0,
              backgroundColor: "#D8F3F4",
              color: "#138B90",
            },
            {
              name: "Walk In",
              value: statData.walkIn || 0,
              backgroundColor: "#FFEDE9",
              color: "#EE3A23",
            },
            {
              name: "Wait List",
              value: statData.waitList || 0,
              backgroundColor: "#EFEBFB",
              color: "#6F32C9",
            },
            {
              name: "Total",
              value: statData.total || 0,
              backgroundColor: "#D8F3F4",
              color: "#008B90",
            },
          ]}
        />
      )}
      {selectedTab === "2" && (
        <RightSideCountTop
          content={[
            {
              name: "Home Delivery Orders/Amount",
              value: `${statData["7"]?.count || 0}/ ₹ ${parseFloat(
                statData["7"]?.amount || 0
              ).toFixed(2)}`,
              backgroundColor: "#FFEDE9",
              color: "#EE3A23",
            },
            {
              name: "Curb Side Orders/Amount",
              value: `${statData["1"]?.count || 0}/ ₹ ${parseFloat(
                statData["1"]?.amount || 0
              ).toFixed(2)}`,
              backgroundColor: "#EFEBFB",
              color: "#6F32C9",
            },
            {
              name: "Dine-In Orders/Amount",
              value: `${statData["3"]?.count || 0}/ ₹ ${parseFloat(
                statData["3"]?.amount || 0
              ).toFixed(2)}`,
              backgroundColor: "#D8F3F4",
              color: "#138B90",
            },
            {
              name: "Skip the Line Order/Amount",
              value: `${statData["2"]?.count || 0}/ ₹ ${parseFloat(
                statData["2"]?.amount || 0
              ).toFixed(2)}`,
              backgroundColor: "#FFEDE9",
              color: "#EE3A23",
            },
            {
              name: "Take Away Orders/Amount",
              value: `${statData["0"]?.count || 0}/ ₹ ${parseFloat(
                statData["0"]?.amount || 0
              ).toFixed(2)}`,
              backgroundColor: "#EFEBFB",
              color: "#6F32C9",
            },
            {
              name: "Total Orders/Amount",
              value: `${
                (statData["0"]?.count || 0) +
                (statData["1"]?.count || 0) +
                (statData["2"]?.count || 0) +
                (statData["3"]?.count || 0) +
                (statData["7"]?.count || 0)
              }/ ₹ ${(
                parseFloat(statData["0"]?.amount || 0) +
                parseFloat(statData["1"]?.amount || 0) +
                parseFloat(statData["2"]?.amount || 0) +
                parseFloat(statData["3"]?.amount || 0) +
                parseFloat(statData["7"]?.amount || 0)
              ).toFixed(2)}`,
              backgroundColor: "#D8F3F4",
              color: "#138B90",
            },
          ]}
        />
      )}
      {selectedTab === "3" && (
        <RightSideCountTop
          content={[
            {
              name: "Ticketed/Amount",
              value: statData.TICKET || 0,
              backgroundColor: "#FFEDE9",
              color: "#EE3A23",
            },
            {
              name: "RSVP",
              value: statData.RSVP || 0,
              backgroundColor: "#EFEBFB",
              color: "#6F32C9",
            },
            {
              name: "Total number of Events",
              value: (statData.TICKET || 0) + (statData.RSVP || 0),
              backgroundColor: "#D8F3F4",
              color: "#138B90",
            },
          ]}
        />
      )}
      {selectedTab === "4" && (
        <RightSideCountTop
          content={[
            {
              name: "Count",
              value: statData.count || 0,
              backgroundColor: "#EFEBFB",
              color: "#6F32C9",
            },
            {
              name: "Amount",
              value: `₹ ${parseFloat(statData?.amount || 0).toFixed(2)}`,
              backgroundColor: "#D8F3F4",
              color: "#138B90",
            },
          ]}
        />
      )}
      {selectedTab === "5" && (
        <RightSideCountTop
          content={[
            {
              name: "Nominated Restaurants",
              value: statData?.count || 0,
              backgroundColor: "#D8F3F4",
              color: "#008B90",
            },
          ]}
        />
      )}
      {selectedTab === "6" && (
        <RightSideCountTop
          content={[
            {
              name: "Favourited Item",
              value: statData.items || 0,
              backgroundColor: "#D8F3F4",
              color: "#008B90",
            },
            {
              name: "Favourited Offers",
              value: statData.offers || 0,
              backgroundColor: "#FFEDE9",
              color: "#EE3A23",
            },
            {
              name: "Favourited Events",
              value: statData.events || 0,
              backgroundColor: "#EFEBFB",
              color: "#6F32C9",
            },

            {
              name: "Favourited Restaurants",
              value: statData.rest || 0,
              backgroundColor: "#D8F3F4",
              color: "#008B90",
            },
          ]}
        />
      )}
      {selectedTab === "7" && (
        <RightSideCountTop
          content={[
            {
              name: "Rated/Reviewed Pay",
              value: statData.pay || 0,

              backgroundColor: "#FFEDE9",
              color: "#EE3A23",
            },
            {
              name: "Rated/Reviewed Items",
              value: statData.items || 0,

              backgroundColor: "#EFEBFB",
              color: "#6F32C9",
            },
            {
              name: "Rated/Reviewed Orders",
              value: statData.offers || 0,
              backgroundColor: "#D8F3F4",
              color: "#138B90",
            },
            {
              name: "Rated/Reviewed Events",
              value: statData.events || 0,
              backgroundColor: "#FFEDE9",
              color: "#EE3A23",
            },
            {
              name: "Rated/Reviewed Seating",
              value: statData.seating || 0,
              backgroundColor: "#EFEBFB",
              color: "#6F32C9",
            },
            {
              name: "Rated/Reviewed Restaurants",
              value: statData.rest || 0,
              backgroundColor: "#D8F3F4",
              color: "#138B90",
            },
          ]}
        />
      )}
      {selectedTab === "8" && (
        <RightSideCountTop
          content={[  
            {
              name: "Total Amount",
              value: `₹ ${parseFloat(statData?.totalAmount || 0).toFixed(2)}`,
              backgroundColor: "#FFEDE9",
              color: "#EE3A23",
            },
            {
              name: "Referred Vendors",
              value:  statData?.vendors || 0,
              backgroundColor: "#EFEBFB",
              color: "#6F32C9",
            },
            {
              name: "Referred Users",
              value: statData.users || 0,
              backgroundColor: "#D8F3F4",
              color: "#138B90",
            },
          ]}
        />
      )}
      {selectedTab === "9" && (
        <RightSideCountTop
          content={[
            {
              name: "User Ordered order",
              value: statData.items || 0,
              backgroundColor: "#D8F3F4",
              color: "#008B90",
            },
            {
              name: "User Attended Events",
              value: statData.events || 0,
              backgroundColor: "#FFEDE9",
              color: "#EE3A23",
            },
            {
              name: "User availed Offers",
              value: statData.offers || 0,
              backgroundColor: "#EFEBFB",
              color: "#6F32C9",
            },
            {
              name: "User Viewed Restaurants",
              value: statData.rest || 0,
              backgroundColor: "#D8F3F4",
              color: "#008B90",
            },
          ]}
        />
      )}
      {selectedTab === "10" && (
        <RightSideCountTop
          content={[
            {
              name: "Total number of Raised Tickets",
              value: statData?.count || 0,
              backgroundColor: "#D8F3F4",
              color: "#138B90",
            },
          ]}
        />
      )}
      {selectedTab === "11" && (
        <RightSideCountTop
          content={[
            {
              name: "Viewed Live Stream",
              value: statData?.total || 0,
              backgroundColor: "#D8F3F4",
              color: "#138B90",
            },
          ]}
        />
      )}
      {selectedTab === "12" && (
        <RightSideCountTop
          content={[
            {
              name: "Total Viwed Videos",
              value: statData?.total || 0,
              backgroundColor: "#FFEDE9",
              color: "#EE3A23",
            },
          ]}
        />
      )}
      {selectedTab === "13" && (
        <RightSideCountTop
          content={[
            {
              name: "Availed Offers",
              value: statData.count || 0,
              backgroundColor: "#FFEDE9",
              color: "#EE3A23",
            },
          ]}
        />

      )}
      {selectedTab === "14" && (
      <RightSideCountTop
      content={[
        {
          name: "Total Reels Watched",
          value: statData.count || 0,
          backgroundColor: "#D8F3F4",
          color: "#138B90",
        },
        {
          name: "Reels Skipped",
          value:  0,
          backgroundColor: "#FFEDE9",
          color: "#EE3A23",
        },
        {
          name: "Reels Tapped",
          value:  0,
          backgroundColor: "#EFEBFB",
          color: "#6F32C9",
        },
        {
          name: "Ordered/Booked",
          value:  0,
          backgroundColor: "#D8F3F4",
          color: "#008B90",
        },
      ]}
    />

      )}
    </>
  );
};

export default UserStats;
